import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { useThemeStore } from './store/themeStore'
import { useAuthStore } from './store/authStore'
import client from './api/client'

export default function App() {
  const theme = useThemeStore((s) => s.theme)
  const { isAuth, setUser } = useAuthStore()
  const [ready, setReady] = useState(!isAuth)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  useEffect(() => {
    if (!isAuth) { setReady(true); return }
    client.get('/api/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => {})
      .finally(() => setReady(true))
  }, [])

  if (!ready) return null

  return <RouterProvider router={router} />
}
